import React from 'react';
import PropTypes from 'prop-types';
import Animated from "animated/lib/targets/react-dom";
import Interactable from "react-interactable/noNative";
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Paper from "@material-ui/core/Paper";
import firebase from './firebase';
import {withRouter} from "react-router-dom";
import { Route } from "react-router-dom";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import SwipeableViews from 'react-swipeable-views';

import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Cookies from "universal-cookie/es6";
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import MenuItem from "@material-ui/core/MenuItem";
import ReactDOM from 'react-dom';

function mapStyles(styles) {
    return {
        opacity: styles.opacity,
        transform: `translateX(${styles.offset})`,

    };
}



function isDate18orMoreYearsOld(day, month, year) {
    return new Date(year+18, month-1, day) <= new Date();
}


function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}


let posX = new Animated.Value(0);

let styles = {
    container: {
        height: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "stretch",
        overflow: "hidden",

    },
    drawerContainer: {
        width: '100vw',
        position: "absolute",
        left: 0,
       /* bottom: 0,*/
        overflow: "hidden",
        zIndex: 3000,
        height: '100vh'
       /* backgroundColor: '#3591FF',*/
    },
    content: {
        backgroundColor: "white",
        flexGrow: 1,
        position: "relative"
    },
    panelContainer: {
        width: window.innerWidth,
        height: 'auto',
        position: "relative",
        transform: 'translateY(calc(100% - 80px))',
        msTransform: 'translateY(-ms-calc(100% - 80px))',
        WebkitTransform: 'translateY(-webkit-calc(100% - 80px))',
        MozTransform: 'translateY(-ms-calc(100% - 80px))',
        OTransform: 'translateY(-o-calc(100% - 80px))',
    },

    leftPanel: {
        width: '100%',
        borderTopLeftRadius: 30,
        borderTopRightRadius: 30,
        maxWidth: '1000px',
        height: "auto",
        zIndex: 2000,
        flex: 1,
        position: "absolute",
        right: 0,
        left: 0,
        margin: 'auto',
        display: 'block',
        backgroundColor: '#C444FE',
    },
    successPanel: {
        width: '100%',
        borderTopLeftRadius: 30,
        borderTopRightRadius: 30,
        maxWidth: '1000px',
        height: "calc(100vh - 60px)",
        zIndex: 2000,
        flex: 1,
        position: "absolute",
        right: 0,
        left: 0,
        margin: 'auto',
        display: 'block',
        backgroundColor: '#C444FE',
    },
    toggle: {
        fontSize: 30,
    },
    inter: {
        position: 'fixed',
        bottom: 0,
        zIndex: 1400,
    }

};

export default withRouter( class SlideUpPanel extends React.Component {

    static propTypes = {
        user: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            panelOpen: false,
            panelHeight: 0,
            toggleStyle: {},
            dni: '',
            birth: '',
            birthSub: false,
            error: false,
            value: 0,
            success: false,
            ID: '',
            name: '',
            lastName: '',
            friendUID: window.location.href.substr(window.location.href.toString().lastIndexOf('/') + 1),
            submited: false,
            dataPolicy: false,
            sex: '',
            labelWith: 100,
            email: '',
            zone: '',
            registerEmail: '',
            redeemed: false,
            restarted: false,
        };
    }

    onRestart = () =>{


        if (!this.state.redeemed && !this.state.restarted){

            this.setState({
                restarted: true,
            });

            var data = {
                email: this.state.registerEmail,
                campaign: 'demogetviral',
                id: this.state.ID
            };

            fetch('https://us-central1-mktviral.cloudfunctions.net/deleteUser', {
                method: 'POST', // or 'PUT'
                body: JSON.stringify(data), // data can be `string` or {object}!
                headers:{
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                res.json().then(val => {
                    console.log(val);

                    this.toggleOpen();
                    this.loginMailClicl();

                    setTimeout(() => {
                        this.setState({
                            dni: '',
                            birth: '',
                            birthSub: false,
                            error: false,
                            value: 0,
                            success: false,
                            ID: '',
                            name: '',
                            lastName: '',
                            friendUID: window.location.href.substr(window.location.href.toString().lastIndexOf('/') + 1),
                            submited: false,
                            dataPolicy: false,
                            sex: '',
                            labelWith: 100,
                            email: '',
                            zone: '',
                            registerEmail: '',
                            redeemed: false,
                            restarted: false,
                        });
                    },500);

                    setTimeout(()=>{
                        this.setState({
                            panelHeight: this.panelRef.offsetHeight,
                            toggleStyle: {
                                ...styles.toggle,
                                transform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                                WebkitTransform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                            },
                            panelOpen: true,
                        });
                        this.componentRef.snapTo({index:1})
                    },1000);

                }).catch(function (error) {
                    console.log(error)
                });
            }).catch(function (error) {
                console.log(error)
            });
        }





    };

    handleChangeIndex = index => {

        const oldIndex = this.state.value;
        this.setState({
            value: index,
        }, () => {
            if (!this.props.login){
                this.setState({
                    value: 0,
                    error: true,
                });
            }
            else if (index === 2){
                if (!this.state.name || !this.state.lastName ){
                    this.setState({
                        value: oldIndex,
                        error: true,
                    });
                }
            }
            else if (index === 3 &&( oldIndex === 2 || oldIndex === 1)){
                if (!validateEmail(this.state.email)){
                    this.setState({
                        value: oldIndex,
                        error: true,
                    });
                }
            }
            else if(index === 4 &&( oldIndex === 3 || oldIndex === 2)){
                if (!this.state.dni){
                    this.setState({
                        value: oldIndex,
                        error: true,
                    });
                }
            }
            else if(index === 5 &&( oldIndex === 4 || oldIndex === 3)){
                if (!this.state.zone){
                    this.setState({
                        value: oldIndex,
                        error: true,
                    });
                }
            }
            else if(index === 6 &&( oldIndex === 5 || oldIndex === 4)){
                if (!this.state.birth){
                    this.setState({
                        value: oldIndex,
                        error: true,
                    });
                }else{
                    this.setState({
                        birthSub: true,
                    });
                    setTimeout(()=>{
                        this.setState({
                            panelHeight: this.panelRef.offsetHeight,
                            toggleStyle: {
                                ...styles.toggle,
                                transform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                                WebkitTransform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                            }

                        });
                        this.componentRef.snapTo({index:1})
                    },500);
                }
            }
            else if (!this.state.success && this.state.value === 7){
                this.setState({
                    value: oldIndex,
                });
            }
            /*else if (index < oldIndex) {
                this.setState({
                    value: oldIndex,
                });
            }*/
        });
    };
    handleChange = name => (event) => {
        var context = this;
        this.setState({
            [name]: event.target.value,
            error: false,
        });
    };

    handleChangeSex = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    toggleRotation = (height) => {
        if (height < 80){
            height = 81;
        }
        return posX.interpolate({
            inputRange: [0, (80 - height) * -1],
            outputRange: [ "0deg", "180deg"]
        })
    };

    loginClick = ()=>{
        var provider = new firebase.auth.FacebookAuthProvider();
        firebase.auth().useDeviceLanguage();
        firebase.auth().signInWithRedirect(provider);
    };
    loginMailClicl = () => {
        this.props.handleChangeLogin();
    };

    /*toggleRotation = posX.interpolate({
        inputRange: [0, (64 - this.state.panelHeight) * -1],
        outputRange: [ "0deg", "180deg"]
    });*/

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged = () =>  {
        console.log("ROUTE CHANGED");
        setTimeout(() => {
            console.log(this.panelRef.offsetHeight);
            this.setState({
                panelHeight: this.panelRef.offsetHeight,
                toggleStyle: {
                    ...styles.toggle,
                    transform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                    WebkitTransform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                }

            })
        },1000);

    };


    componentWillReceiveProps(nextProps, nextContext) {

        if (nextProps.login){
            if (nextProps.login !== this.props.login && nextProps.uid !== this.props.uid ){
                setTimeout(() => {
                    this.toggleOpen();
                    this.setState({ value: 1 });
                    console.log(this.panelRef.offsetHeight);
                    this.setState({
                        panelHeight: this.panelRef.offsetHeight,
                        toggleStyle: {
                            ...styles.toggle,
                            transform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                            WebkitTransform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                        }

                    })
                },500);
            }
            else if (nextProps.login !== this.props.login) {
                setTimeout(() => {
                    this.setState({ value: 1 });
                    console.log(this.panelRef.offsetHeight);
                    this.setState({
                        panelHeight: this.panelRef.offsetHeight,
                        toggleStyle: {
                            ...styles.toggle,
                            transform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                            WebkitTransform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                        }

                    })
                },500);
            }
        }

        if (nextProps.email){
            this.setState({
                email: nextProps.email,
            })
        }
        if (nextProps.name){
            this.setState({
                name: nextProps.name,
            })
        }
        if (nextProps.lastName){
            this.setState({
                lastName: nextProps.lastName,
            })
        }
    }


    componentDidMount() {

        /*this.setState({
            labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth,
        });*/

        const cookies = new Cookies();
        var birthday = cookies.get('birthday');
        this.setState({
            birth: birthday
        });

        setTimeout(()=>{
            this.setState({
                panelHeight: this.panelRef.offsetHeight,
                toggleStyle: {
                    ...styles.toggle,
                    transform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                    WebkitTransform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
                }

            })
        },500);

       this.setState({
           panelHeight: this.panelRef.offsetHeight,
           toggleStyle: {
               ...styles.toggle,
               transform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
               WebkitTransform: [{ rotate: this.toggleRotation(this.panelRef.offsetHeight) }],
           }

       })
    }
    /*toggleStyle = {
        ...styles.toggle,
        transform: [{ rotate: this.toggleRotation() }]
    };*/

    toggleOpen = () => {
        /*this.setState({panelContainerStyle: styles.panelContainerOpened})*/
        if (this.state.panelOpen){
            this.componentRef.snapTo({index: 0});
            this.setState({panelOpen: false})
        } else {
            this.componentRef.snapTo({index: 1});
            this.setState({panelOpen: true})
        }
    };

    onNext = ()=> {
        this.handleChangeIndex(this.state.value + 1);
        /*if (this.state.value < 2){
            if (this.state.name && this.state.lastName){
                this.handleChangeIndex(2);
            }
            else {
                this.setState({
                    error: true,
                })
            }
        }
        else if (this.state.value < 3){
            if (this.state.email){
                this.handleChangeIndex(3);
            }
            else {
                this.setState({
                    error: true,
                })
            }
        }
        else if (this.state.value < 4){
            if (this.state.dni && this.state.dni.length > 6){
                this.handleChangeIndex(4);
            }
            else {
                this.setState({
                    error: true,
                })
            }
        }
        else if (this.state.value < 5){
            if (this.state.zone){
                this.handleChangeIndex(5);
            }
            else {
                this.setState({
                    error: true,
                })
            }
        }
        else if (this.state.value < 6){
            var date = new Date(this.state.birth);
            if (this.state.birth && isDate18orMoreYearsOld(date.getDay(), date.getMonth(), date.getFullYear())){
                this.handleChangeIndex(6);
            }
            else {
                this.setState({
                    error: true,
                })
            }
        }*/

        if(this.state.value === 6) {

            if (!this.state.submited) {
                if (this.state.dataPolicy){

                    this.setState({
                        submited: true
                    });

                    var db = firebase.firestore();
                    const context = this;
                    let timestamp = firebase.firestore.FieldValue.serverTimestamp();
                    if (this.props.fid) {
                        db.collection('users').where('campaign', '==', 'demogetviral').where('email','==', this.state.email).get()
                            .then(function (snapshot) {
                                if (snapshot.size > 0){
                                    snapshot.forEach(function(doc) {
                                        context.setState({ID: doc.id});
                                        context.setState({
                                            success: true,
                                            value: 7,
                                            registerEmail: doc.data().email,
                                            redeemed: doc.data().validated,
                                        });
                                        setTimeout(()=>{
                                            context.setState({
                                                panelHeight: context.panelRef.offsetHeight - 65,
                                                toggleStyle: {
                                                    ...styles.toggle,
                                                    transform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                    WebkitTransform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                }

                                            });
                                            context.componentRef.snapTo({index:1})
                                        },500);
                                    });

                                }else {

                                    db.collection('users').where('campaign', '==', 'demogetviral').where('fid','==', context.props.fid).get()
                                        .then(function (snapshot) {
                                            if (snapshot.size > 0){
                                                snapshot.forEach(function(doc) {
                                                    context.setState({ID: doc.id});
                                                    context.setState({
                                                        success: true,
                                                        value: 7,
                                                        registerEmail: doc.data().email,
                                                        redeemed: doc.data().validated,
                                                    });
                                                    setTimeout(()=>{
                                                        context.setState({
                                                            panelHeight: context.panelRef.offsetHeight - 65,
                                                            toggleStyle: {
                                                                ...styles.toggle,
                                                                transform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                                WebkitTransform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                            }

                                                        });
                                                        context.componentRef.snapTo({index:1})
                                                    },500);
                                                });

                                            }
                                            else {

                                                db.collection('users').where('campaign', '==', 'demogetviral').where('dni','==', context.state.dni).get()
                                                    .then(function (snapshot) {
                                                        if (snapshot.size > 0){
                                                            snapshot.forEach(function(doc) {
                                                                context.setState({ID: doc.id});
                                                                context.setState({
                                                                    success: true,
                                                                    value: 7,
                                                                    registerEmail: doc.data().email,
                                                                    redeemed: doc.data().validated,
                                                                });
                                                                setTimeout(()=>{
                                                                    context.setState({
                                                                        panelHeight: context.panelRef.offsetHeight - 65,
                                                                        toggleStyle: {
                                                                            ...styles.toggle,
                                                                            transform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                                            WebkitTransform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                                        }

                                                                    });
                                                                    context.componentRef.snapTo({index:1})
                                                                },500);
                                                            });

                                                        }
                                                        else {
                                                            db.collection('users').add({
                                                                name: context.state.name,
                                                                lastName: context.state.lastName,
                                                                email: context.state.email,
                                                                birth: context.state.birth,
                                                                dni: context.state.dni,
                                                                friendUID: context.state.friendUID,
                                                                campaign: 'demogetviral',
                                                                validated: false,
                                                                shareTo: 0,
                                                                shareToRegister: 0,
                                                                fid: context.props.fid,
                                                                createdAt: timestamp,
                                                                sex: context.state.sex,
                                                                zone: context.state.zone
                                                            }).then(function (doc) {
                                                                context.setState({ID: doc.id});
                                                                context.setState({
                                                                    success: true,
                                                                    value: 7,
                                                                    registerEmail: context.state.email,
                                                                });
                                                                setTimeout(()=>{
                                                                    context.setState({
                                                                        panelHeight: context.panelRef.offsetHeight - 65,
                                                                        toggleStyle: {
                                                                            ...styles.toggle,
                                                                            transform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                                            WebkitTransform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                                        }

                                                                    });
                                                                    context.componentRef.snapTo({index:1})
                                                                },500);

                                                                if (context.state.friendUID){
                                                                    var friendRef = db.collection('users').doc(context.state.friendUID);
                                                                    db.runTransaction(function(transaction) {
                                                                        return transaction.get(friendRef).then(function(doc) {
                                                                            if (!doc.exists) {
                                                                                throw "Document does not exist!";
                                                                            }

                                                                            var newShare = doc.data().shareToRegister + 1;
                                                                            transaction.update(friendRef, { shareToRegister: newShare });
                                                                        });
                                                                    })
                                                                }
                                                            })
                                                        }
                                                    })

                                            }
                                        });


                                }
                            });
                    }
                    else
                    {
                        db.collection('users').where('campaign', '==', 'demogetviral').where('email','==', this.state.email).get()
                            .then(function (snapshot) {
                                if (snapshot.size > 0){
                                    snapshot.forEach(function(doc) {
                                        context.setState({ID: doc.id});
                                        context.setState({
                                            success: true,
                                            value: 7,
                                            registerEmail: doc.data().email,
                                            redeemed: doc.data().validated,
                                        });
                                        setTimeout(()=>{
                                            context.setState({
                                                panelHeight: context.panelRef.offsetHeight - 65,
                                                toggleStyle: {
                                                    ...styles.toggle,
                                                    transform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                    WebkitTransform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                }

                                            });
                                            context.componentRef.snapTo({index:1})
                                        },500);
                                    });

                                }else {

                                    db.collection('users').where('campaign', '==', 'demogetviral').where('dni','==', context.state.dni).get()
                                        .then(function (snapshot) {
                                            if (snapshot.size > 0){
                                                snapshot.forEach(function(doc) {
                                                    context.setState({ID: doc.id});
                                                    context.setState({
                                                        success: true,
                                                        value: 7,
                                                        registerEmail: doc.data().email,
                                                        redeemed: doc.data().validated,
                                                    });
                                                    setTimeout(()=>{
                                                        context.setState({
                                                            panelHeight: context.panelRef.offsetHeight - 65,
                                                            toggleStyle: {
                                                                ...styles.toggle,
                                                                transform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                                WebkitTransform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                            }

                                                        });
                                                        context.componentRef.snapTo({index:1})
                                                    },500);
                                                });

                                            }
                                            else {
                                                db.collection('users').add({
                                                    name: context.state.name,
                                                    lastName: context.state.lastName,
                                                    email: context.state.email,
                                                    birth: context.state.birth,
                                                    dni: context.state.dni,
                                                    friendUID: context.state.friendUID,
                                                    campaign: 'demogetviral',
                                                    validated: false,
                                                    shareTo: 0,
                                                    shareToRegister: 0,
                                                    createdAt: timestamp,
                                                    sex: context.state.sex,
                                                    zone: context.state.zone
                                                }).then(function (doc) {
                                                    context.setState({ID: doc.id});
                                                    context.setState({
                                                        success: true,
                                                        value: 7,
                                                        registerEmail: context.state.email,
                                                    });
                                                    setTimeout(()=>{
                                                        context.setState({
                                                            panelHeight: context.panelRef.offsetHeight - 65,
                                                            toggleStyle: {
                                                                ...styles.toggle,
                                                                transform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                                WebkitTransform: [{ rotate: context.toggleRotation(context.panelRef.offsetHeight - 65) }],
                                                            }

                                                        });
                                                        context.componentRef.snapTo({index:1})
                                                    },500);

                                                    if (context.state.friendUID){
                                                        var friendRef = db.collection('users').doc(context.state.friendUID);
                                                        db.runTransaction(function(transaction) {
                                                            return transaction.get(friendRef).then(function(doc) {
                                                                if (!doc.exists) {
                                                                    throw "Document does not exist!";
                                                                }

                                                                var newShare = doc.data().shareToRegister + 1;
                                                                transaction.update(friendRef, { shareToRegister: newShare });
                                                            });
                                                        })
                                                    }
                                                })
                                            }
                                        })
                                }
                            });
                    }





                } else {
                    this.setState({
                        error: true,
                    })
                }

            }



        }
    };
    handleChangePolicy = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    render() {
        const theme = createMuiTheme({
            palette: {
              /*  primary: {
                    // light: will be calculated from palette.primary.main,
                    main: '#151F2A',
                    // dark: will be calculated from palette.primary.main,
                    // contrastText: will be calculated to contrast with palette.primary.main
                    contrastText: '#EDAA00'
                },*/
                  primary: {
                      // light: will be calculated from palette.primary.main,
                      main: '#ffffff',
                      // dark: will be calculated from palette.primary.main,
                      // contrastText: will be calculated to contrast with palette.primary.main
                      contrastText: '#000000'
                  },
                secondary: {
                    main: '#ff0013',
                    // dark: will be calculated from palette.primary.main,
                    // contrastText: will be calculated to contrast with palette.primary.main
                    contrastText: '#ffffff'
                },
                error: {
                    main: '#fff',
                    // dark: will be calculated from palette.primary.main,
                    // contrastText: will be calculated to contrast with palette.primary.main
                    contrastText: '#ff0013'
                }
            },
            typography: { useNextVariants: true },
        });
        return (
            <MuiThemeProvider theme={theme}>
                        <Interactable.View
                            ref={el => (this.componentRef = el)}
                            animatedValueY={posX}
                            boundaries={{top: 80 - this.state.panelHeight, bottom: 0, bounce: 1}}
                            snapPoints={[{ y: 0 }, { y: 80 -this.state.panelHeight }]}
                            verticalOnly={true}
                            style={styles.inter}
                        >
                            <div style={styles.panelContainer}   >
                                <Paper className={'panel'} style={this.state.success ? styles.successPanel : styles.leftPanel} variant="contained" color="primary" ref={el => (this.panelRef = el)}>
                                    <div onClick={this.toggleOpen}>
                                        <Animated.div  style={this.state.toggleStyle}><i style={{color: '#ffffff'}} className={'ion-md-arrow-dropup'}/></Animated.div>
                                        <p className={'startLoginPTitle'}> {
                                            this.state.success ?
                                             '🕹️ Brindemos' : '🕹️ Empecemos'
                                        } </p>
                                    </div>
                                        <SwipeableViews
                                            index={this.state.value}
                                            onChangeIndex={this.handleChangeIndex}
                                        >
                                            <div>
                                                <p className={'startLoginPTitle'}> {
                                                    'Elegí un método de ingreso'
                                                } </p>
                                                <Button onClick={this.loginClick}  variant="contained" color="primary"
                                                        className={"loginButton modalButton loginStartButton buyButton2 "}>
                                                    FACEBOOK LOGIN
                                                </Button>
                                                <Button onClick={this.loginMailClicl}  variant="contained" color="primary"
                                                        className={"loginButton modalButton loginStartButton buyButton2 "}>
                                                    E-MAIL LOGIN
                                                </Button>

                                            </div>
                                            <div>
                                                <p className={'startLoginPTitle'}> {
                                                    'Ingresá tu nombre y apellido'
                                                } </p>
                                                <TextField
                                                    value={this.state.name}
                                                    onChange={this.handleChange('name')}
                                                    error={this.state.error}
                                                    label="Nombre"
                                                    className="fieldModal loginDetails"
                                                    margin="normal"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: '',
                                                            focused: 'inputCustomLogin',
                                                        },
                                                    }}
                                                    InputProps={{
                                                        classes: {
                                                            root: 'inputCustomLogin',
                                                            focused: 'inputCustomLogin',
                                                            notchedOutline: this.state.error ? 'errorInput' : 'inputCustomLogin',
                                                            error: 'errorInput',
                                                        },
                                                    }}
                                                />
                                                <TextField
                                                    value={this.state.lastName}
                                                    onChange={this.handleChange('lastName')}
                                                    error={this.state.error}
                                                    label="Apellido"
                                                    className="fieldModal loginDetails"
                                                    margin="normal"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: '',
                                                            error: 'errorInput',
                                                            focused: 'inputCustomLogin',
                                                        },
                                                    }}
                                                    InputProps={{
                                                        classes: {
                                                            root: 'inputCustomLogin',
                                                            focused: 'inputCustomLogin',
                                                            notchedOutline: this.state.error ? 'errorInput' : 'inputCustomLogin',
                                                            error: 'errorInput',
                                                        },
                                                    }}
                                                />

                                            </div>
                                            <div>
                                                <p className={'startLoginPTitle'}> {
                                                    this.props.uid ? 'Confirma tu e-mail' : 'E-mail de confirmación'
                                                } </p>
                                                <TextField
                                                    value={this.state.email}
                                                    onChange={this.handleChange('email')}
                                                    error={this.state.error}
                                                    label="E-mail"
                                                    type="email"
                                                    className="fieldModal loginDetails"
                                                    margin="normal"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: '',
                                                            focused: 'inputCustomLogin',
                                                        },
                                                    }}
                                                    InputProps={{
                                                        classes: {
                                                            root: 'inputCustomLogin',
                                                            focused: 'inputCustomLogin',
                                                            notchedOutline: this.state.error ? 'errorInput' : 'inputCustomLogin',
                                                            error: 'errorInput',
                                                        },
                                                    }}
                                                />

                                            </div>

                                            <div>
                                                <p className={'startLoginPTitle'}> {
                                                    'Ingresá tu documento y sexo'
                                                } </p>
                                                <TextField
                                                    value={this.state.dni}
                                                    onChange={this.handleChange('dni')}
                                                    error={this.state.error}
                                                    label="Documento"
                                                    type="number"
                                                    className="fieldModal loginDetails"
                                                    margin="normal"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: '',
                                                            focused: 'inputCustomLogin',
                                                        },
                                                    }}
                                                    InputProps={{
                                                        classes: {
                                                            root: 'inputCustomLogin',
                                                            focused: 'inputCustomLogin',
                                                            notchedOutline: this.state.error ? 'errorInput' : 'inputCustomLogin',
                                                            error: 'errorInput',
                                                        },
                                                    }}
                                                />
                                                <FormControl variant="outlined" className={'inputCustomLogin fieldModal loginDetails'}>
                                                    <InputLabel
                                                        ref={ref => {
                                                            this.InputLabelRef = ref;
                                                        }}
                                                        htmlFor="outlined-age-simple"
                                                    >
                                                        Sexo
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.sex}
                                                        onChange={this.handleChange('sex')}
                                                        inputProps={{
                                                            classes: {
                                                                root: 'inputCustomLogin',
                                                                select: 'inputCustomLogin',
                                                            },
                                                        }}
                                                        input={
                                                            <OutlinedInput
                                                                className={'inputCustomLogin'}
                                                                labelWidth={40}
                                                            />
                                                        }
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={'female'}>Femenino</MenuItem>
                                                        <MenuItem value={'male'}>Masculino</MenuItem>
                                                        <MenuItem value={'non'}>No identifica</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div>
                                                <p className={'startLoginPTitle'}> {
                                                    '¿De dónde sos?'
                                                } </p>
                                                <FormControl variant="outlined" className={'inputCustomLogin fieldModal loginDetails'}>
                                                    <InputLabel
                                                        ref={ref => {
                                                            this.InputLabelRef = ref;
                                                        }}
                                                        htmlFor="outlined-age-simple"
                                                    >
                                                        Zona
                                                    </InputLabel>
                                                    <Select
                                                        value={this.state.zone}
                                                        onChange={this.handleChange('zone')}
                                                        inputProps={{
                                                            classes: {
                                                                root: 'inputCustomLogin',
                                                                select: 'inputCustomLogin',
                                                            },
                                                        }}
                                                        input={
                                                            <OutlinedInput
                                                                className={'inputCustomLogin'}
                                                                labelWidth={40}
                                                            />
                                                        }
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        <MenuItem value={'Buenos Aires'}>Buenos Aires</MenuItem>
                                                        <MenuItem value={'Catamarca'}>Catamarca</MenuItem>
                                                        <MenuItem value={'Caba'}>CABA</MenuItem>
                                                        <MenuItem value={'Chaco'}>Chaco</MenuItem>
                                                        <MenuItem value={'Chubut'}>Chubut</MenuItem>
                                                        <MenuItem value={'Córdoba'}>Córdoba</MenuItem>
                                                        <MenuItem value={'Corrientes'}>Corrientes</MenuItem>
                                                        <MenuItem value={'Entre Ríos'}>Entre Ríos</MenuItem>
                                                        <MenuItem value={'Formosa'}>Formosa</MenuItem>
                                                        <MenuItem value={'La Pampa'}>La Pampa</MenuItem>
                                                        <MenuItem value={'La Rioja'}>La Rioja</MenuItem>
                                                        <MenuItem value={'Mendoza'}>Mendoza</MenuItem>
                                                        <MenuItem value={'Misiones'}>Misiones</MenuItem>
                                                        <MenuItem value={'Neuquén'}>Neuquén</MenuItem>
                                                        <MenuItem value={'Río Negro'}>Río Negro</MenuItem>
                                                        <MenuItem value={'Salta'}>Salta</MenuItem>
                                                        <MenuItem value={'San Juan'}>San Juan</MenuItem>
                                                        <MenuItem value={'San Luis'}>San Luis</MenuItem>
                                                        <MenuItem value={'Santa Cruz'}>Santa Cruz</MenuItem>
                                                        <MenuItem value={'Santa Fe'}>Santa Fe</MenuItem>
                                                        <MenuItem value={'Santiago del Estero'}>Santiago del Estero</MenuItem>
                                                        <MenuItem value={'Tierra del Fuego'}>Tierra del Fuego</MenuItem>
                                                        <MenuItem value={'Tucumán'}>Tucumán</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </div>
                                            <div>
                                                <p className={'startLoginPTitle'}> {
                                                    'Ingresá tu fecha de nacimiento'
                                                } </p>
                                                <TextField
                                                    value={this.state.birth}
                                                    onChange={this.handleChange('birth')}
                                                    error={this.state.error}
                                                    label=""
                                                    type="date"
                                                    className="fieldModal loginDetails"
                                                    margin="normal"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        classes: {
                                                            root: '',
                                                            focused: 'inputCustomLogin',
                                                        },
                                                    }}
                                                    InputProps={{
                                                        classes: {
                                                            root: 'inputCustomLogin',
                                                            focused: 'inputCustomLogin',
                                                            notchedOutline: this.state.error ? 'errorInput' : 'inputCustomLogin',
                                                            error: 'errorInput',
                                                        },
                                                    }}
                                                />
                                            </div>

                                            <div>
                                                <p className={'startLoginPTitle'}> {
                                                    'Bases y condiciones'
                                                } </p>
                                                {this.state.birthSub &&
                                                <p className={'dataPolicyText'}>
                                                    El participante declara que la información suministrada por él, incluyendo la relacionada con sus datos personales, es cierta, fidedigna y actualizada.

                                                    <br/>•	Los datos personales y demás información suministrados por el participante en este concurso serán objeto de tratamiento automatizado e incorporada a la base de datos administrada por el área de Itesa Innovation Company S.A.S. encargada de desarrollar la campaña o actividad promocional.

                                                    <br/>•	El participante presta su consentimiento libre, expreso e informado para que la información personal que ha ingresado sea almacenada, recopilada o utilizada por Itesa Innovation Company S.A.S. directamente o a través de terceros, con fines de comunicación, envío de información y/o para el mercadeo de sus productos.

                                                    <br/>•	La información suministrada será objeto de protección mediante el uso de tecnologías y procedimientos de seguridad evitando el acceso, revelación y usos no autorizados.
                                                </p>
                                                }
                                                <div className={'dataPolicyContainer'}>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={this.state.dataPolicy}
                                                                onChange={this.handleChangePolicy('dataPolicy')}
                                                                value='dataPolicy'
                                                                color="primary"
                                                                classes={{
                                                                    root: 'dataPolicy',
                                                                    checked: 'dataPolicyChecked',
                                                                }}
                                                            />
                                                        }
                                                        label="Acepto términos de política de datos"
                                                        className={'dataPolicy'}
                                                    />
                                                </div>


                                            </div>
                                            <div>
                                                {this.state.success &&
                                                <p className={'startLoginPTitle successTitle'}> {
                                                    'Enviamos tu pinta a ' + this.state.registerEmail +
                                                    '. Revisá, y canjeá tu pinta en nuestras oficinas. ¿Ya sabés con quién vas a ir? Invitá a tus amigos.'
                                                } </p>}
                                                {/*{this.state.success && <img className={'successImage'} src={successImage}/>}*/}


                                                {this.state.success &&
                                                <Button variant="contained" color="primary"
                                                        className={"loginButton modalButton loginStartButton buyButton2 successButton "}
                                                         href={"https://api.whatsapp.com/send?text=" + this.state.name +
                                                         '%20quiere%20invitarte%20una%20pinta.%0A%C2%A1Registrate%20y%20prob%C3%A1%20nuestra%20cerveza%20edici%C3%B3n%20limitada%21%20https%3A%2F%2Fdemo.getviral.me%2F' + this.state.ID}
                                                        >
                                                    COMPARTIR CON TUS AMIGOS
                                                </Button>}
                                               {/* <Button variant="contained" color="primary"
                                                        className={"loginButton modalButton loginStartButton buyButton2 successButton "}
                                                        href={"http://www.cervezapatagonia.com.ar/refugios"}
                                                >
                                                    ELEGÍ TU REFUGIO
                                                </Button>*/}
                                                {this.state.success &&
                                                <p className={'startLoginPTitle successTitle'}> {
                                                    'Si ' + this.state.registerEmail +' no es tu e-mail o esta mal escrito toca aca:'
                                                } </p>}
                                                {this.state.success &&
                                                <Button onClick={this.onRestart} variant="contained" color="secondary"
                                                        className={"loginButton modalButton loginStartButton buyButton2 successButton "}
                                                        >
                                                    {this.state.restarted && <CircularProgress color={'primary'} />}
                                                    {!this.state.restarted && 'VOLVER A EMPEZAR'}

                                                </Button>}

                                            </div>
                                        </SwipeableViews>
                                        {!this.state.success &&
                                        <div className={'bottomContainer'}>
                                            <div style={{marginLeft: '5%'}} className={this.state.value === 0 ? 'pageBall ballSelected' : 'pageBall'}/>
                                            <div className={this.state.value === 1 ? 'pageBall ballSelected' : 'pageBall'}/>
                                            <div className={this.state.value === 2 ? 'pageBall ballSelected' : 'pageBall'}/>
                                            <div className={this.state.value === 3 ? 'pageBall ballSelected' : 'pageBall'}/>
                                            <div className={this.state.value === 4 ? 'pageBall ballSelected' : 'pageBall'}/>
                                            <div className={this.state.value === 5 ? 'pageBall ballSelected' : 'pageBall'}/>
                                            <div className={this.state.value === 6 ? 'pageBall ballSelected' : 'pageBall'}/>
                                            {this.props.login &&
                                            <Button onClick={this.onNext} color="primary" className={'nextButton'}>

                                                {
                                                    this.state.value < 6 && 'Siguiente'
                                                }
                                                {
                                                    this.state.value === 6 && !this.state.submited && 'Finalizar'
                                                }
                                            </Button>}

                                            {this.props.login && this.state.submited && this.state.value === 6 &&
                                            <CircularProgress className={'nextButton progressCircular'} />
                                           }

                                        </div>
                                        }

                                </Paper>
                            </div>
                        </Interactable.View>
            </MuiThemeProvider>

        )
    }
})
